import { Component, OnInit } from '@angular/core';
import { BaseListComponent } from '../../../../shared/base/base-list.component'
import { RouteAuthorities, ValueLabel, BooleanFields } from 'src/app/shared/base/base.models';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { RequestService } from '../../../../core/request.service';
import { BaseService } from 'src/app/shared/base/base.service';
import { TranslateService } from '@ngx-translate/core';
import { Constants, SearchOperations } from 'src/app/app.constants';
import { OfferedProduct } from '../offered-products.models';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';
import { Product } from '../../products/products.models';
import { Badge } from '../../badges/badges.models';
import { CompaniesService } from '../../companies/companies.service';
import { Company, CompanyType } from '../../companies/companies.models';

@Component({
  selector: 'app-offered-products-list',
  templateUrl: './offered-products-list.component.html',
  styleUrls: ['./offered-products-list.component.scss']
})
export class OfferedProductsListComponent extends BaseListComponent implements OnInit {
  public gridStateKey: string = 'offered-products_list_state_grid';
  public lookupColumns: Array<string> = ['pointOfSale.name', 'product.code', 'product.name', 'amountAvailable', 'regularPrice', 'affectsMinimumOrderValue', 'affectsRebateBase', 'specialTreatment'];

  public templateAttributeDataTypes: ValueLabel[] = [];

  public offeredProductStatuses: ValueLabel[] = [];
  public booleanFields: ValueLabel[] = [];
  public reportCode: string = 'OFFRD';
  private company: Company;

  constructor(
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService,
    private companiesService: CompaniesService
  ) {
    super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
    this.authorities = new RouteAuthorities(authService, alertService, 'CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.creatable = this.authorities.create;
    this.editable = this.authorities.update;
    this.deletable = this.authorities.delete;
    this.activatable = this.authorities.update;
  }

  async ngOnInit() {
    //don't show offered-products that have inactive products    
    let activeProducts = `product${SearchOperations.SPLIT_JOIN_OPERATOR}active${SearchOperations.EQUALITY}${true}`;

    this.companiesService.getCompany(this.authService.companyId).then((company)=> {
      this.company = company;
      if(company.companyType == CompanyType[CompanyType.B2B])
        this.reportCode = 'B2BOFFRD'
    });

    this.url = `${Constants.contextPath}/offered-products`;
    this.prepareLookupData();
    this.getGridData(activeProducts);
  }

  private prepareLookupData() {
    this.offeredProductStatuses = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(BooleanFields, true), 'value', 'label', 'ENUMS.OFFERED_PRODUCT_STATUS.');
    this.booleanFields = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(BooleanFields, true), 'value', 'label', 'ENUMS.BOOLEAN_FIELDS.');

  }

  public loadGridState = (): any => {
    return this.loadGridStateBase(this.gridStateKey, this.lookupColumns);
  }

  public saveGridState = (state: any): void => {
    this.saveGridStateBase(state, this.gridStateKey, this.lookupColumns);
  }

  public updateAffectsRebate(id: string, value: boolean): void {
    this.baseService.getById(this.url, id, (offeredProduct: OfferedProduct) => {
      offeredProduct.affectsRebateBase = value;

      if (offeredProduct.pointOfSale) {
        let pointOfSale = <PointOfSale>offeredProduct.pointOfSale;
        offeredProduct.pointOfSale = <string>pointOfSale.id;
      }

      if (offeredProduct.product) {
        let product = <Product>offeredProduct.product;
        offeredProduct.product = <string>product.id;
      }

      if(offeredProduct.badges) {
        let badges = offeredProduct.badges.map(b => <Badge>b.id);
        offeredProduct.badges = badges;
      }
      
      let activeProducts = `product${SearchOperations.SPLIT_JOIN_OPERATOR}active${SearchOperations.EQUALITY}${true}`;
      this.baseService.update(this.url, offeredProduct, () => this.getGridData(activeProducts, true))
    });
  }

  public updateAffectsMinimum(id: string, value: boolean): void {
    this.baseService.getById(this.url, id, (offeredProduct: OfferedProduct) => {
      offeredProduct.affectsMinimumOrderValue = value;

      if (offeredProduct.pointOfSale) {
        let pointOfSale = <PointOfSale>offeredProduct.pointOfSale;
        offeredProduct.pointOfSale = <string>pointOfSale.id;
      }

      if (offeredProduct.product) {
        let product = <Product>offeredProduct.product;
        offeredProduct.product = <string>product.id;
      }

      if(offeredProduct.badges) {
        let badges = offeredProduct.badges.map(b => <Badge>b.id);
        offeredProduct.badges = badges;
      }
      
      let activeProducts = `product${SearchOperations.SPLIT_JOIN_OPERATOR}active${SearchOperations.EQUALITY}${true}`;
      this.baseService.update(this.url, offeredProduct, () => this.getGridData(activeProducts, true))
    });
  }

  public updateSpecialTreatment(id: string, value: boolean): void {
    this.baseService.getById(this.url, id, (offeredProduct: OfferedProduct) => {
      offeredProduct.specialTreatment = value;

      if (offeredProduct.pointOfSale) {
        let pointOfSale = <PointOfSale>offeredProduct.pointOfSale;
        offeredProduct.pointOfSale = <string>pointOfSale.id;
      }

      if (offeredProduct.product) {
        let product = <Product>offeredProduct.product;
        offeredProduct.product = <string>product.id;
      }

      if(offeredProduct.badges) {
        let badges = offeredProduct.badges.map(b => <Badge>b.id);
        offeredProduct.badges = badges;
      }
      
      let activeProducts = `product${SearchOperations.SPLIT_JOIN_OPERATOR}active${SearchOperations.EQUALITY}${true}`;
      this.baseService.update(this.url, offeredProduct, () => this.getGridData(activeProducts, true))
    });
  }
}